/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "MYB",
  title: "Hello world, I'm Mohammad Yasin",
  subTitle: emoji(
    "A passionate full-stack software developer having experience in building web applications with javascript / reactjs / nodejs / and some other cool libraries and frameworks."
  ),
   // resumeLink:
   //  "", 
  resumeLink:
    "https://drive.google.com/file/d/1LTobqPEd7ymJD_XYuHsssczyfNeBInOR/view?usp=drivesdk", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/myb12",
  linkedin: "https://www.linkedin.com/in/mohammad-yasin-bappy/",
  gmail: "mohammadyasinbappy@gmail.com",
  twitter: "https://twitter.com/mybappy12",
  facebook: "https://www.facebook.com/mybappy12",
  // gitlab: "",
  // facebook: "",
  // medium: "",
  // stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "I do ui/ux design for the website that helps website to get a unique look."
    ),
    emoji("I also develop the websites. I create high performance website with blazing fast speed."),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5",
      color: '#e44d26'
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt",
      color: '#264de4'
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
      color: '#f7df1e'
    },
    {
      skillName: "ReactJS",
      fontAwesomeClassname: "fab fa-react",
      color: '#00d8ff'
    },
    {
      skillName: "Redux",
      fontAwesomeClassname: "redux",
      color: '#764abc'
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab fa-react",
      color: '#61dafb'
    },
    {
      skillName: "Material UI",
      fontAwesomeClassname: "mui",
      color: '#007fff'
    },
    {
      skillName: "React Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap",
      color: '#7410f0'
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "tailwind",
      color: '#01b7d6'
    },
    {
      skillName: "REST API",
      fontAwesomeClassname: "api",
      color: '#0082c6'
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire",
      color: '#fcca3f'
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
      color: '#cc3534'
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node",
      color: '#8bc500'
    },
    {
      skillName: "ExpressJS",
      fontAwesomeClassname: "express",
      color: '#333331'
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "mongo",
      color: '#07ab4f'
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php",
      color: '#4e5b92'
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel",
      color: '#f35045'
    },
    {
      skillName: "MySQL",
      fontAwesomeClassname: "mysql",
      color: '#006c94'
    },
    {
      skillName: "Figma",
      fontAwesomeClassname: "fab fa-figma",
      color: '#f24e1e'
    },
    {
      skillName: "Illustrator",
      fontAwesomeClassname: "ai",
      color: '#ff9b00'
    },
    {
      skillName: "Photoshop",
      fontAwesomeClassname: "photoshop",
      color: '#31a8ff'
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    // {
    //   schoolName: "Technische Universität Ilmenau, Germany",
    //   logo: require("./assets/images/TU_Ilmenau.jpeg"),
    //   subHeader: "M.Sc. – Research in Computer & Systems Engineering",
    //   duration: "April 2026 - Present",
    //   desc: "",
    //   descBullets: []
    // },
    {
      schoolName: "University of Science & Technology, Chittagong",
      logo: require("./assets/images/USTC.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "March 2014 - December 2018",
      desc: "",
      descBullets: []
    },
    {
      schoolName: "Institute of Business Administration (IBA), University of Dhaka",
      logo: require("./assets/images/Dhaka_University_logo.png"),
      subHeader: "Advanced Certificate for Management Professionals (ACMP)",
      duration: "January  2025",
      desc: "Core Topics:",
      descBullets: ["Communication",
        "Financial Accounting",
        "Marketing",
        "Marketing Strategy",
        "Project Management",
        "Agile Methodologies",
        "People Management",
        "Data-driven Decision Making"]
    },
    // {
    //   schoolName: "BAF Shaheen College, Chittagong",
    //   logo: require("./assets/images/BAF.png"),
    //   subHeader: "Higher Secondary Certificate (HSC)",
    //   duration: "January 2011 - December 2012",
    //   desc: "",
    //   descBullets: []
    // }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "60%"
    },
    {
      Stack: "UX",
      progressPercentage: "70%"
    },
    {
      Stack: "Graphics Design",
      progressPercentage: "50%"
    },
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Staff Software Engineer",
      company: "SELISE Group",
      companylogo: require("./assets/images/selise_logo.jpeg"),
      date: "September 2025 - Present",
    },
    {
      role: "Software Engineer",
      company: "Adventure Dhaka Limited",
      companylogo: require("./assets/images/adventure.jpeg"),
      date: "March 2025 - August 2025",
    },
    {
      role: "Web Developer",
      company: "Prothom Alo",
      companylogo: require("./assets/images/prothom-alo.png"),
      date: "October 2022 – February 2025",
    },
    {
      role: "Software Engineer",
      company: "Mediusware Ltd.",
      companylogo: require("./assets/images/mediusware.png"),
      date: "February 2022 – September 2022",
      // desc: "Job Responsibilities",
      // descBullets: [
      //   'Developing new user - facing features using React.js',
      //   'Building reusable components and front - end libraries for future use.',
      //   'Translating designs and wireframes into high quality code.',
      //   'Troubleshooting interface soware and debugging application codes.'
      // ]
    },
    // {
    //   role: "Web Instructor",
    //   company: "Programming Hero",
    //   companylogo: require("./assets/images/phero.jpg"),
    //   date: "January 2022 – February 2022",
    //   // desc: "Job Responsibilities",
    //   // descBullets: [
    //   //   'Helping students understand concepts of HTML, CSS, JavaScript, ReactJs, etc.',
    //   //   'Solve the bugs that students face during their project.',
    //   //   'Checking projects of students that are given to them as assignments.'
    //   // ]
    // },
    // {
    //   role: "Front-end Developer (ReactJs)",
    //   company: "TechHack Canada",
    //   companylogo: require("./assets/images/techhack.png"),
    //   date: "October 2021 – December 2021",
    //   // desc: "Job Responsibilities",
    //   // descBullets: [
    //   //   'Designing UX using Figma.',
    //   //   'Developing new user - facing features using React.js',
    //   //   'Building reusable components for future use.',
    //   //   'Translating designs and wireframes into high quality code.',
    //   //   'Troubleshooting interface soware and debugging application codes.'
    //   // ]
    // },
    {
      role: "Junior Web Developer",
      company: "Softimize",
      // company: "AnalytiQ",
      companylogo: require("./assets/images/softimize.png"),
      // companylogo: require("./assets/images/analytiQ.jpeg"),
      // date: "November 2019 – December 2021",
      // date: "February 2020 – December 2021",
      // role: "Web Developer",
      // company: "Softimize.Tech",
      // companylogo: require("./assets/images/softimize.png"),
      date: "November 2019 – December 2021",
      //       desc: "Job Responsibilities",
      //       descBullets: [
      //         'Designing and implementing web applications using Laravel framework.',
      //         'Build efficient, testable, and reusable PHP module.',
      //         'Implementing server side logic to process front inputs.',
      //         'Interacting with MySQL databases.',
      //         'Identifying and fixing bugs that are found within code.'
      //       ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some projects you have worked on

const projects = {
  titleHome: "Recent Projects",
  titleAll: "Projects",
  subtitle: "",
  projects: [
    {
      _id: 1,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/myb-watches.33f7a31a.jpg",
      projectName: "MYB Stylish Watches",
      projectDesc: "A watch related MERN Stack Niche website",
      overview: [
        'A responsive single-page web app built with the MERN Stack.',
        'A simple user can register and log in using email & password also using Google.',
        'After login, he/she can order a product, cancel the order, and can give a review of a product.',
        'An admin can add a product, remove a product, cancel an order, change the order status, and can make a new admin using the persons email address.'
      ],
      technologies: [
        'ReactJs', 'HTML', 'CSS', 'Material UI', 'React Router', 'React hook', 'Firebase', 'Context API', 'NodeJs', 'ExpressJs', 'MongoDB', 'JWT Token'
      ],
      liveLink: 'https://myb-stylish-watches.web.app/',
      client: 'https://github.com/myb12/myb-stylish-watches-client',
      server: 'https://github.com/myb12/myb-stylish-watches-server',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/d2s9LCf/mw-1.png",
        },
        {
          src:
            " https://i.ibb.co/Y38HmgX/mw-2.png",
        },
        {
          src:
            " https://i.ibb.co/RDwmS4Y/mw-3.png",
        },
        {
          src:
            " https://i.ibb.co/pXCsh1d/mw-4.png",
        },
        {
          src:
            "https://i.ibb.co/GkTFDqm/mw-5.png",
        },
        {
          src:
            "https://i.ibb.co/yqKzHvq/mw-6.png",
        },

      ],
    },
    {
      _id: 2,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/myb-travel.fa8181f2.jpg",
      projectName: "MYB Travels",
      projectDesc: "A Tour & Travel related MERN Stack website",
      overview: [
        'Developed a single-page fully responsive MERN Stack web app to sell tour packages.',
        'A client can sign in using Google.',
        'While logged in he/she can order a package and can also cancel the order.',
        'The client can add a new package, can remove the existing packages, and can change the order status.',
        'If the client is not logged in he/she cannot order a package but he/she can see the packages.'
      ],
      technologies: [
        'ReactJs', 'HTML', 'CSS', 'Bootstrap', 'React Router', 'React hook', 'Firebase', 'Context API', 'NodeJs', 'ExpressJs', 'MongoDB'
      ],
      liveLink: 'https://myb-travel.web.app/',
      client: 'https://github.com/myb12/myb-travels-client',
      server: 'https://github.com/myb12/myb-travels-server',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/vQYZct7/mt-1.png",
        },
        {
          src:
            "https://i.ibb.co/SBxf66B/mt-2.png",
        },
        {
          src:
            "https://i.ibb.co/Fm55Fsn/mt-3.png",
        },
        {
          src:
            "https://i.ibb.co/hL7bCpt/mt-4.png",
        },
        {
          src:
            "https://i.ibb.co/Qd0xJFd/mt-5.png",
        },
        {
          src:
            "https://i.ibb.co/W6v3XJv/mt-6.png",
        },

      ],
    },
    {
      _id: 3,
      image: "https://i.ibb.co/WgZtdYf/red-home.jpg",
      projectName: "Red Onion",
      projectDesc: "A simple food related Single-page application",
      overview: [
        'Developed a responsive single-page react application to provide food for users.',
        'A user can see the foods.',
        'To add a food to cart the user needs to login in the website.',
        'The user can sign in using Google.',
        'After successfully logging in the user can see the details of the food and can add the food to cart.'
      ],
      technologies: [
        'ReactJs', 'HTML', 'CSS', 'Bootstrap', 'React Router', 'React hook', 'react-icons', 'Firebase', ' Context API'
      ],
      liveLink: 'https://red-onion-cb5df.web.app/',
      client: 'https://github.com/myb12/red-onion',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],

      snaps: [
        {
          src:
            "https://i.ibb.co/pKCh11Y/red-1.png",
        },
        {
          src:
            "https://i.ibb.co/TcmGSBV/red-2.png",
        },
        {
          src:
            "https://i.ibb.co/fYQZM0X/red-3.png",
        },
        {
          src:
            "https://i.ibb.co/P4yMKsW/red-4.png",
        },
        {
          src:
            "https://i.ibb.co/s5KrgJg/red-5.png",
        },
        {
          src:
            "https://i.ibb.co/mc8yLxv/red-6.png",
        },

      ],
    },

    {
      _id: 4,
      image: "https://i.ibb.co/CW27twT/cs1.png",
      projectName: "Simple Landing Page",
      projectDesc: "A simple Landing Page developed using ReactJS",
      overview: [
        'Developed a responsive single-page react application designed without any css framework or any other library or package',
        'There are two types of sliders that are built without using any package',
        'There is a customized accordion which is built without using any library',
      ],
      technologies: [
        'ReactJs', 'HTML', 'CSS',
      ],
      liveLink: 'https://codeshaper-landing-page.netlify.app/',
      client: 'https://github.com/myb12/cs-assignment',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],

      snaps: [
        {
          src:
            "https://i.ibb.co/CW27twT/cs1.png",
        },
        {
          src:
            "https://i.ibb.co/RzXymht/cs2.pngg",
        },
        {
          src:
            "https://i.ibb.co/sKr9wX5/cs3.png",
        },
        {
          src:
            "https://i.ibb.co/6RLnpns/cs4.png",
        },
        {
          src:
            "https://i.ibb.co/X8XDLCd/cs5.png",
        },
        {
          src:
            "https://i.ibb.co/C53WmMQ/cs6.png",
        },

      ],
    },

    {
      _id: 5,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/doctors-house.64211a5c.jpg",
      projectName: "Doctor's House",
      projectDesc: "A simple health care related website",
      overview: [
        'Architected a responsive single - page react app to serve health care.',
        'A simple user can see the services and can also read the articles.',
        'The user can register using email and password.',
        'He/she can sign in with that email and password Besides, the user can simply sign in using Google.',
        'After successfully logging in the user can see the details of any of the services available in our application by clicking on that specific service.'
      ],
      technologies: [
        'ReactJs', 'HTML', 'CSS', 'Bootstrap', 'React Router', 'React hook', 'Firebase', ' Context API'
      ],
      liveLink: 'https://doctors-house-1ec0a.web.app/',
      client: 'https://github.com/myb12/doctors-house',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/9cKyLpb/dr-1.png",
        },
        {
          src:
            "https://i.ibb.co/WxvcgKy/dr-2.png",
        },
        {
          src:
            "https://i.ibb.co/cNCF53c/dr-3.png",
        },
        {
          src:
            "https://i.ibb.co/7tn56LX/dr-4.png",
        },
        {
          src:
            "https://i.ibb.co/sv13dVQ/dr-5.png",
        },
        {
          src:
            "https://i.ibb.co/QrLbw1k/dr-6.png",
        },

      ],
    },

    {
      _id: 6,
      image: "https://i.ibb.co/BKbLDHx/port1.png",
      projectName: "Personal Portfolio",
      projectDesc: "Personal portfolio - a single-page react application",
      overview: [
        'Architected a responsive single-page react application for personal portfolio.',
        'All the data are fetched from fakedata.',
      ],
      technologies: [
        'ReactJs', 'HTML', 'Styled-component', 'React Router', 'React hook', 'SwiperJs'
      ],
      liveLink: 'https://mohammad-yasin-v1.netlify.app/',
      client: 'https://github.com/myb12/my_portfolio_react',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/BKbLDHx/port1.png",
        },
        {
          src:
            "https://i.ibb.co/fv03MX2/port2.png",
        },
        {
          src:
            " https://i.ibb.co/PwqswgW/port3.png",
        },
        {
          src:
            "https://i.ibb.co/y6wb6gb/port4.png",
        },
        {
          src:
            "https://i.ibb.co/LpKgr6v/port5.png",
        },
        {
          src:
            "https://i.ibb.co/4WhHnfv/port6.png",
        },

      ],
    },

    {
      _id: 7,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/mentorian.8360287e.jpg",
      projectName: "Mentorian Opportunities",
      projectDesc: "A laravel application related to jobs, internships and workshops",
      overview: [
        'Developed a responsive Laravel application to serve opportunities such as job, internships, and workshoprs.',
        'A user can see the the job,internship or workshop posts.',
        'The user can register using email and password.',
        'Admin can add, edit and remove all kinds of job,internship and workshops',
      ],
      technologies: [
        'HTML', 'CSS', 'Bootstrap', 'JavaScript', 'AJAX', 'PHP', 'Laravel', 'MySQL'
      ],
      liveLink: 'https://myb12.github.io/mentorian-opportunities/',
      client: 'https://github.com/myb12/mentorian',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/kQcQpcj/mentorian-home.png",
        },
        {
          src:
            " https://i.ibb.co/dg5VMnF/mentorian1.png",
        },
        {
          src:
            "https://i.ibb.co/MMgPcj5/mentorian2.png",
        },
        {
          src:
            "https://i.ibb.co/gvBT1sn/mentorian3.png",
        },
        {
          src:
            "https://i.ibb.co/kQbP0dn/Capture2.png",
        },
        {
          src:
            "https://i.ibb.co/ZBn1HtQ/Capture.png",
        },

      ],
    },

    {
      _id: 8,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/recipe.41343d67.jpg",
      projectName: "Recipe App",
      projectDesc: "A simple JavaScript application to provide recipe",
      overview: [
        'Developed a website with HTML, CSS, JavaScript and Forkify API ',
        'A user can search for food',
        'The user can bookmark any recipe that are saved in localstorage',
        'The user can add a new recipe',
        'The user can change the number of serving from the UI and according to that the amount of recipe ingredients will also be changed'
      ],
      technologies: [
        'HTML', 'CSS', 'JavaScript', 'OOP', 'Forkify API', 'localstorage'
      ],
      liveLink: 'https://recipe-app-yasin.netlify.app/',
      client: 'https://github.com/myb12/recipe-app',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/XjcvwyS/recipe.png",
        },
        {
          src:
            "https://i.ibb.co/Zm4pZv2/recipe3.png",
        },
        {
          src:
            "https://i.ibb.co/vj6x4B5/recipe-modal.png",
        }


      ],
    },

    {
      _id: 9,
      image: "https://i.ibb.co/ryMNbHT/mapty.png",
      projectName: "Mapty - map your workouts",
      projectDesc: "A simple JavaScript application to keep track of your daily workout",
      overview: [
        'Developed a website with HTML, CSS, JavaScript and Forkify API ',
        'A user can add a marker on the map where he.she wants to workout',
        'After clicking on the map the user can add a specific workout on that position ',
        'The user can remove any workout',
        'Usersworkout data are stored in localstorage'
      ],
      technologies: [
        'HTML', 'CSS', 'JavaScript', 'Geolocation API.'
      ],
      liveLink: 'https://myb12.github.io/mapty/',
      client: 'https://github.com/myb12/mapty',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/ryMNbHT/mapty.png",
        },
        {
          src:
            "https://i.ibb.co/ryMNbHT/mapty.png",
        },
        {
          src:
            "https://i.ibb.co/ryMNbHT/mapty.png",
        },
      ],
    },

    {
      _id: 10,
      image: "https://i.ibb.co/CzbzZhX/bankist1.png",
      projectName: "Bankist Website",
      projectDesc: "A simple JavaScript application with some custom components",
      overview: [
        'Architect a website with HTML, CSS and JavaScript',
        'where some components are created manually only using vanila JavaScript. such as',
        'Lazy loading image',
        'Reveal component after scrolling a certain position',
        'Custom slider for testimonial and custom tabs',
        'Custom modal is created using vanila JavaScript'
      ],
      technologies: [
        'HTML', 'CSS', 'JavaScript', 'Intersection observer API'
      ],
      liveLink: 'https://myb12.github.io/bankist/',
      client: 'https://github.com/myb12/bankist',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/kxjXXbJ/bankist2.png",
        },
        {
          src:
            "https://i.ibb.co/k6dQydW/bankist3.png",
        },
        {
          src:
            "https://i.ibb.co/0yN3vL2/bankist4.png",
        },
      ],
    },

    {
      _id: 11,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/weather.19dfc789.jpg",
      projectName: "Weather Update",
      projectDesc: "A JavaScript application to get weather update",
      overview: [
        'Developed a Weather update application using JavaScript and openweathermap API',
        'A user can search by any city name to get current weather',
      ],
      technologies: [
        'HTML', 'CSS', 'JavaScript', 'openweathermap API'
      ],
      liveLink: 'https://mohammad-yasin-weather-update.netlify.app/',
      client: 'https://github.com/myb12/weather-update',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/weather.19dfc789.jpg",
        },
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/weather.19dfc789.jpg",
        },
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/weather.19dfc789.jpg",
        },
      ],
    },

    {
      _id: 12,
      image: "https://mohammad-yasin-v1.netlify.app/static/media/where_am_i.2d941cdb.PNG",
      projectName: "Where I am",
      projectDesc: "A JavaScript application to know current location",
      overview: [
        'Built a simple Javscript application using geolocation API and restcountries API',
        'A user is able to know his current location by simply clicking a button',
      ],
      technologies: [
        'HTML', 'CSS', 'JavaScript', 'geolocation API', 'restcountries API'
      ],
      liveLink: 'https://myb12.github.io/where_am_i/',
      client: 'https://github.com/myb12/where_am_i',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/where_am_i.2d941cdb.PNG",
        },
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/where_am_i.2d941cdb.PNG",
        },
        {
          src:
            "https://mohammad-yasin-v1.netlify.app/static/media/where_am_i.2d941cdb.PNG",
        },
      ],
    },
    {
      _id: 13,
      image: "https://i.ibb.co/SnZdqs6/honda1.png",
      projectName: "Honda CBR",
      projectDesc: "A simple landing page of Honda CBR website",
      overview: [
        'Designed a simple landing page of Honda CBR using HTML, CSS & Bootstrap',
      ],
      technologies: [
        'HTML', 'CSS', 'Bootstrap'
      ],
      liveLink: 'https://honda-cbr-mohammad-yasin.netlify.app/',
      client: 'https://github.com/myb12/honda-cbr',
      server: '',
      footerLink: [
        {
          name: "Visit Website",
        }
        //  you can add extra buttons here.
      ],
      snaps: [
        {
          src:
            "https://i.ibb.co/SnZdqs6/honda1.png",
        },
        {
          src:
            "https://i.ibb.co/WFRxLp5/honda2.png",
        },
        {
          src:
            "https://i.ibb.co/vBg6stS/honda3.png",
        },
        {
          src:
            "https://i.ibb.co/tD2mgYg/honda4.png",
        },
        {
          src:
            "https://i.ibb.co/wh4CRQF/honda5.png",
        },
        {
          src:
            "https://i.ibb.co/dKnkvDF/honda6.png",
        },
      ],
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me"),
  subtitle:
    "Have a project in mind? Let me help you!",
  number: "+8801674687835",
  email_address: "mohammadyasinbappy@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  projects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
